const store = {
    namespaced: true,
    state() {
        return {
            mainCategories: [],
            viewMode: null,
        };
    },
    getters: {
        getMainCategories: state => state.mainCategories,
        getViewMode: state => state.viewMode,
    },
    mutations: {
        SET_MAIN_CATEGORIES: (state, data) => (state.mainCategories = data),
        SET_VIEW_MODE: (state, data) => (state.viewMode = data),
    },
    actions: {
        async fetchMainCategory({ commit }) {
            try {
                const { categories, view_mode } = await this.$axios.$get('base/main_page_similar_category');
                if (categories && categories?.length) {
                    commit('SET_VIEW_MODE', view_mode);
                    commit('SET_MAIN_CATEGORIES', categories);
                }
            } catch (error) {
                console.error('Error fetching main page similar category:', error);
            }
        },
    },
};

export default store;
